"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageTransport = void 0;
var LocalStorageTransport = /** @class */ (function () {
    function LocalStorageTransport(url) {
        this.url = url;
        this.disabled = typeof Storage === 'undefined';
        if (!this.disabled) {
            var data = localStorage.getItem(LOG_KEY);
            if (data && data.length > 0) {
                this.sendPostRequest(data);
                localStorage.removeItem(LOG_KEY);
            }
        }
    }
    LocalStorageTransport.prototype.send = function (data) {
        if (this.disabled) {
            return;
        }
        var cachedData = localStorage.getItem(LOG_KEY);
        var ret;
        if (cachedData && cachedData.length > 0) {
            ret = this.concatJsonArray(cachedData, JSON.stringify(data));
        }
        else {
            ret = JSON.stringify(data);
        }
        if (ret.length < MAX_LOG_SIZE) {
            localStorage.setItem(LOG_KEY, ret);
        }
        else {
            // Drop all logs and disable the transport when the log size exceeds the size limit.
            localStorage.removeItem(LOG_KEY);
            this.disabled = true;
        }
    };
    LocalStorageTransport.prototype.sendPostRequest = function (data) {
        var request = new XMLHttpRequest();
        request.open('POST', this.url);
        request.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
        request.send(data);
    };
    LocalStorageTransport.prototype.concatJsonArray = function (str1, str2) {
        return "[".concat(str1.substring(1, str1.length - 1), ",").concat(str2.substring(1, str2.length - 1), "]");
    };
    return LocalStorageTransport;
}());
exports.LocalStorageTransport = LocalStorageTransport;
var LOG_KEY = 'indeed-ac-log';
var MAX_LOG_SIZE = 500 * 1024; // 500KB
//# sourceMappingURL=data:application/json;base64,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